import Component from '../abstracts/Component';

export default class LookBookComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-lookbook',
      markersContainer: '.js-markers-container',
      marker: '.js-marker'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    const components = document.querySelectorAll(this.SELECTORS.main);

    components.forEach(comp => {
      let markers = comp.querySelectorAll(this.SELECTORS.marker);
      for (let marker of markers) {
        marker.addEventListener('click', e => {
          e.stopPropagation();
          const parent = e.currentTarget.parentElement;
          parent.classList.toggle('markers-visible');
        })
      }
    });
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }
}
